export default __webpack_public_path__ + "static/media/agency-lg-2.7caadab3.webp";